import {
  Sidebar,
  SidebarInset,
  SidebarHeader,
  SidebarFooter,
  SidebarContent,
  SidebarProvider,
  SidebarRail,
} from "ui/components/sidebar";
import { SwitchApp } from "./components/switch-app";
import { NavUser } from "@/layouts/sidebar/components/nav-user";
import NavHeader from "./components/nav-header";
import { NavMain } from "./components/nav/main";

export default function CaseStudySidebar() {
  return (
    <SidebarProvider>
      <Sidebar collapsible="icon">
        <SidebarHeader>
          <NavHeader />
        </SidebarHeader>
        <SidebarContent>
          <NavMain />
        </SidebarContent>
        <SidebarFooter>
          <SwitchApp />
          <NavUser />
        </SidebarFooter>
        <SidebarRail />
      </Sidebar>
      <SidebarInset></SidebarInset>
    </SidebarProvider>
  );
}
